import {
  STOCK_MASSIVE_UPLOAD_BEGIN,
  STOCK_MASSIVE_UPLOAD_SUCCESS,
  STOCK_MASSIVE_UPLOAD_FAILURE,
  STOCK_MASSIVE_UPLOAD_ERROR,
  STOCK_MASSIVE_UPLOAD_DISMISS_ERROR,
} from './constants';

import { BFFAgent } from '../../../common/BFFAgent';
import { errorGetter } from '../../common/backend/ApiErrorMessage';

export function uploadMassiveStock() {

  return async (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: STOCK_MASSIVE_UPLOAD_BEGIN,
    });
    const { stock: { massiveUploadFile } } = getState();

    try {
      const result = await BFFAgent.Catalogs.uploadCargaMasiva(massiveUploadFile);
      if (result?.data?.status === 'error') {
        dispatch({
          type: STOCK_MASSIVE_UPLOAD_ERROR,
          data: result.data.message,
        })
      }
      else {
        const translatorSteps = Object.values(result.data.schema).filter(step => step.requiresValidation)
        dispatch({
          type: STOCK_MASSIVE_UPLOAD_SUCCESS,
          data: {
            carLotPermissions: result.data.carLotPermissions,
            schema: result.data.schema,
            stocks: result.data.stocks,
            translatorSteps,
          },
        });
      }
    } catch (err) {
      let errorMessage = errorGetter(err);

      dispatch({
        type: STOCK_MASSIVE_UPLOAD_FAILURE,
        data: { error: errorMessage },
      });
    }
  }
}

export function dismissUploadMassiveStock() {
  return {
    type: STOCK_MASSIVE_UPLOAD_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_MASSIVE_UPLOAD_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        massiveUploadPending: true,
        massiveUploadError: null,
        carLotConfirmPending: false,
      };

    case STOCK_MASSIVE_UPLOAD_SUCCESS:
      // The request is success
      return {
        ...state,
        massiveUploadPending: false,
        massiveUploadError: null,
        carLotConfirmPending: true,
        massiveUploadFile: null,
        massiveUploadDropzoneStatus: 'normal',
        schema: action.data.schema,
        carLotPermissions: action.data.carLotPermissions,
        stocks: action.data.stocks,
        translatorSteps: action.data.translatorSteps,
      };

    case STOCK_MASSIVE_UPLOAD_ERROR: 
      return {
        ...state,
        massiveUploadPending: false,
        massiveUploadError: action.data,
        massiveUploadDropzoneStatus: 'error',
      }

    case STOCK_MASSIVE_UPLOAD_FAILURE:
      // The request is failed
      return {
        ...state,
        massiveUploadPending: false,
        massiveUploadError: action.data.error,
      };

    case STOCK_MASSIVE_UPLOAD_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        massiveUploadError: null,
      };

    default:
      return state;
  }
}